module.exports = __webpack_public_path__ + "static/img/recovery.a439a69d.png";